export const redirectBrowserTo = (url: string) => {
  window.location.assign(url);
};
